import { useState, useRef, useEffect } from 'react';
import { copyAutomation } from '../../../services/AutomationsService';

/**
 * props:
 * - data
 */
function ViewAutomationModal(props) {
    const DEFAULT_AUTOMATION = {
        id: 0,
        symbol: '',
        name: '',
        conditions: '',
        indexes: '',
        user: {}
    }

    const btnClose = useRef('');
    const [automation, setAutomation] = useState(DEFAULT_AUTOMATION);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!props.data || !props.data.id)
            setAutomation({ ...DEFAULT_AUTOMATION });
        else
            setAutomation(props.data);
    }, [props.data])

    useEffect(() => {
        const modal = document.getElementById('modalViewAutomation');
        modal.addEventListener('hidden.bs.modal', (event) => {
            setAutomation({ ...DEFAULT_AUTOMATION });
            setError('');
        })
    }, [])

    function onCopyClick(event) {
        copyAutomation(automation.id)
            .then(result => {
                btnClose.current.click();
                return window.location.reload();
            })
            .catch(err => setError(err.response ? err.response.data : err.message))
    }

    return (
        <div className="modal fade" id="modalViewAutomation" tabIndex="-1" role="dialog" aria-labelledby="modalTitleNotify" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <p className="modal-title">Detalhes da Automação</p>
                        <button ref={btnClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-6 mb-3"><b>Símbolo:</b> {automation.symbol}</div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3"><b>Nome:</b> {automation.name}</div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3"><b>Autor:</b> {automation.user ? automation.user.name : ''}</div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3"><b>Índices:</b> {automation.indexes}</div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3"><b>Condições:</b> {automation.conditions}</div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        {
                            error
                                ? <div className="alert alert-danger mt-1 col-7 py-1">{error}</div>
                                : <></>
                        }
                        <button type="button" className="btn btn-sm btn-primary" onClick={onCopyClick}>
                            <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" /><path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" /></svg>
                            Copiar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewAutomationModal;
